import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteIndexModal = ({ show, onHide, indexName, handleDeleteIndex }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete Index</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the index <strong>{indexName}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={() => handleDeleteIndex(indexName)}
          className="me-2"
        >
          Confirm
        </Button>
        <Button
          variant="secondary"
          onClick={onHide}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteIndexModal;